import { Component, ViewContainerRef } from '@angular/core';
import { Faq } from '../../models/faq/faq-model'
import { FaqCategory } from '../../models/faq/faq-category-model'
import { FaqService } from '../../services/faq/faq.service';
import { FaqCategoryService } from '../../services/faq/faq-category.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router, ActivatedRoute, Params } from "@angular/router";
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
    selector: 'app-create-faq',
    templateUrl: './create-faq.component.html',
    styleUrls: ['./create-faq.component.css']
})
/** create-faq component*/
export class CreateFaqComponent {
    /** create-faq ctor */
  faqModel = new Faq();
  FaqList: FaqCategory[];

  errorMessage: any;
  constructor(private readonly faqService: FaqService, private readonly faqcatService: FaqCategoryService,
    public toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("faq").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {

            this.getFaqCategories();
            this.toastr.setRootViewContainerRef(vcr);
            this.faqModel.faqCategoryID = null;

          }
          else {
            this.router.navigate(["/faqs"]);
          }
        }
        else {
          this.router.navigate(["/faqs"]);
        }
      }
    )
  }
  ngSubmit() {

    this.faqService.AddFaq(this.faqModel).subscribe(result => {
      if (result) {
        this.toastr.success('FAQ has been Saved. ', 'Success');
        setTimeout(() => {
          this.router.navigate(["/faqs"]);
        }, 2000);
      }
      else {
        this.toastr.error('Error occurred. Oop!', 'Success');
      }
    });
  }
  getFaqCategories() {
    this.faqcatService.getFaqCategories().subscribe(
      data => {
        this.FaqList = data 
      } 
    ) 
  } 
 
}



// WEBPACK FOOTER //
// ./src/app/faq-components/create-faq/create-faq.component.ts